import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  getAllCategory,
  getAllVendors
} from '../../../store/actions/user/User';
import PlacesWithStandaloneSearchBox from './map';
import store from '../../../store/reducers/rootReducer';
import CircularProgress from '@material-ui/core/CircularProgress';

class Home2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      load: false
    };
  }
  componentWillMount() {
    //  useScript('https://use.typekit.net/foobar.js');
    store.dispatch({
      type: 'GET_CART',
      payload: { data: JSON.parse(localStorage.getItem('cart')) }
    });
  }

  getVendors(category) {
    if (
      category === 'Restaurant' ||
      category === 'restaurant' ||
      category === 'Restaurants' ||
      category === 'restaurants'
    ) {
      this.props.history.push('/vendors2/' + category);
    } else {
      this.props.history.push('/vendors/' + category);
    }
  }

  runLoader() {
    this.setState({ load: true });
    setTimeout(() => {
      this.setState({ load: false });
    }, 1500);
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-12 col-sm-5 offset-sm-3">
            <PlacesWithStandaloneSearchBox></PlacesWithStandaloneSearchBox>
          </div>
          <div className="col-12 col-sm-4" style={{ textAlign: 'left' }}>
            {!this.state.load ? (
              <button
                className="btn btn-outline-success btn-lg my-2 my-sm-0 col-auto col-lg-4"
                onClick={this.runLoader}
              >
                Search
              </button>
            ) : (
              <CircularProgress color="secondary" />
            )}
          </div>
        </div>
        <div className="row row-content mb-5">
          <div className="col">
            <div className="carousel slide " data-ride="carousel">
              <img
                src="./img/logo_img/Untitled-3.jpg"
                alt="Lorem"
                className="d-block "
              />
              <div id="carouselOptions" className="d-none d-lg-block ">
                <div className="col-md-6">
                  <Link to="#">
                    <img
                      src="./img/app_storet.png"
                      style={{
                        width: '170px',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      }}
                      alt=""
                    />
                  </Link>
                  <a href="https://play.google.com/store/apps/details?id=com.grospick">
                    <img
                      src="./img/google_playt.png"
                      style={{
                        width: '170px',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                      }}
                      alt=""
                    />
                  </a>
                </div>
                <div className="col-md-2"></div>
                <div className="col-md-2" style={{ marginLeft: '8%' }}>
                  <Link
                    to="/"
                    data-toggle="modal"
                    data-target="#myModal"
                    className="nav-link"
                  >
                    <img
                      src="./img/imageedit_9_6121394194.png"
                      style={{
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        paddingBottom: '10px'
                      }}
                      alt=""
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section>
          <div className="container">
            <h2>
              <b>What do you want to get done?</b>
            </h2>
            <br />
            <div
              className="row no-gutters ftco-services"
              style={{ border: '2px solid', borderRadius: '5px' }}
            >
              <div
                className="col-lg-2 col-md-3 col-6  text-center align-self-stretch ftco-animate d-none d-lg-flex"
                style={{ backgroundColor: '#8080803d' }}
              >
                <div className="media-body">
                  <h5 className="heading">
                    <b>
                      <br />
                      Do more on <br />
                      the Grospick <br /> App
                      <br />
                    </b>
                  </h5>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-6  text-center d-flex align-self-stretch ftco-animate">
                <Link to="/vendors2/Restaurant">
                  <div className="">
                    <div className="col-12">
                      <span>
                        <img src="./img/icon_img/29.png" alt="" />
                      </span>
                    </div>
                    <div className="col-12">
                      <h3 className="heading">Restaurants</h3>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6  text-center d-flex align-self-stretch ftco-animate">
                <Link to="/vendors/Grocery">
                  <div className="">
                    <div className="col-12">
                      <span>
                        <img src="./img/icon_img/12.png" alt="" />
                      </span>
                    </div>
                    <div className="col-12">
                      <h3 className="heading">Daily Grocery</h3>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6  text-center d-flex align-self-stretch ftco-animate">
                <Link to="/vendors/Food">
                  <div className="">
                    <div className="col-12">
                      <span>
                        <img src="./img/icon_img/27.png" alt="" />
                      </span>
                    </div>
                    <div className="col-12">
                      <h3 className="heading">Fruits and Vegetables</h3>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6  text-center d-flex align-self-stretch ftco-animate">
                <Link to="/vendors/Medicine">
                  <div className="">
                    <div className="col-12">
                      <span>
                        <img src="./img/icon_img/16.png" alt="" />
                      </span>
                    </div>
                    <div className="col-12">
                      <h3 className="heading">Medicine</h3>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6  text-center d-flex align-self-stretch ftco-animate">
                <Link to="/vendors/Liquor">
                  <div className="">
                    <div className="col-12">
                      <span>
                        <img src="./img/icon_img/a-6.png" alt="" />
                      </span>
                    </div>
                    <div className="col-12">
                      <h3 className="heading">Meat and Fish</h3>
                    </div>
                  </div>
                </Link>
              </div>

              <div
                className="col-lg-2 col-md-3 col-6  text-center align-self-stretch ftco-animate d-none d-lg-flex"
                style={{ backgroundColor: '#8080803d' }}
              >
                <div className="media-body">
                  <Link to="#">
                    <h5 className="heading">
                      <b>
                        <br />
                        Download <br /> App
                        <br />
                      </b>
                    </h5>
                  </Link>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-6  text-center d-flex align-self-stretch ftco-animate">
                <Link to="/vendors">
                  <div className="">
                    <div className="col-12">
                      <span>
                        <img src="./img/icon_img/22.png" alt="" />
                      </span>
                    </div>
                    <div className="col-12">
                      <h3 className="heading">Pet Supplies</h3>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6  text-center d-flex align-self-stretch ftco-animate">
                <Link to="/vendors">
                  <div className="">
                    <div className="col-12">
                      <span>
                        <img src="./img/icon_img/f-1.png" alt="" />
                      </span>
                    </div>
                    <div className="col-12">
                      <h3 className="heading">Health and Wellness</h3>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6  text-center d-flex align-self-stretch ftco-animate">
                <Link to="/vendors">
                  <div className="">
                    <div className="col-12">
                      <span>
                        <img src="./img/icon_img/a-1.png" alt="" />
                      </span>
                    </div>
                    <div className="col-12">
                      <h3 className="heading">Gifts for Your Loved ones</h3>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6  text-center d-flex align-self-stretch ftco-animate">
                <Link to="/vendors">
                  <div className="">
                    <div className="col-12">
                      <span>
                        <img src="./img/icon_img/18.png" alt="" />
                      </span>
                    </div>
                    <div className="col-12">
                      <h3 className="heading">Other stores</h3>
                    </div>
                  </div>
                </Link>
              </div>
              <div className="col-lg-2 col-md-3 col-6  text-center d-flex align-self-stretch ftco-animate">
                <Link to="/vendors">
                  <div className="">
                    <div className="col-12">
                      <span>
                        <img src="./img/icon_img/20.png" alt="" />
                      </span>
                    </div>
                    <div className="col-12">
                      <h3 className="heading">send package</h3>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <br />

        <div className="container">
          <h2>
            <b>Your machine time is here</b>
          </h2>
          <br />
          <div className="row no-gutters ftco-services">
            <div className="col-md-3 text-center d-flex align-self-stretch ftco-animate">
              <div className="row">
                <div className="col-12">
                  <span>
                    <img
                      src="./img/logo/icon-1.png"
                      style={{ marginLeft: 'auto', marginRight: 'auto' }}
                      alt=""
                    />
                  </span>
                </div>
                <div className="col-12">
                  <h3 className="heading">Order Food Grocery and More</h3>
                </div>
              </div>
            </div>
            <div className="col-md-3 text-center d-flex align-self-stretch ftco-animate">
              <div className="row">
                <div className="col-12">
                  <span>
                    <img
                      src="./img/logo/icon-2.png"
                      style={{ marginLeft: 'auto', marginRight: 'auto' }}
                      alt=""
                    />
                  </span>
                </div>
                <div className="col-12">
                  <h3 className="heading">Under 60 Minute Delivery</h3>
                </div>
              </div>
            </div>
            <div className="col-md-3 text-center d-flex align-self-stretch ftco-animate">
              <div className="row">
                <div className="col-12">
                  <span>
                    <img
                      src="./img/logo/icon-3.png"
                      style={{ marginLeft: 'auto', marginRight: 'auto' }}
                      alt=""
                    />
                  </span>
                </div>
                <div className="col-12">
                  <h3 className="heading">Exciting Deal And Offers</h3>
                </div>
              </div>
            </div>
            <div className="col-md-3 text-center d-flex align-self-stretch ftco-animate">
              <div className="row">
                <div className="col-12">
                  <span
                    className="fa fa-clock-o "
                    style={{ fontSize: '100px' }}
                  ></span>
                </div>
                <div className="col-12">
                  <h3 className="heading">24/7 Support</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateWithProps = (state) => ({
  categories: state.user.categories,
  loader: state.ui.user_loading
});

const mapDispatchToProps = (dispatch) => ({
  getAllCategory: () => dispatch(getAllCategory()),
  getAllVendors: (city, latitude, longitude, category) =>
    dispatch(getAllVendors(city, latitude, longitude, category))
});

export default connect(mapStateWithProps, mapDispatchToProps)(Home2);
